import { z } from 'zod';

const SourceSchema = z.object({
  file: z.string().min(1),
  line: z.number().int().optional()
}).optional();

export const ActionCategorySchema = z.enum([
  'navigation',
  'mutation',
  'query',
  'effect'
]);

export const ActionDefinitionSchema = z.object({
  name: z.string().min(1),
  handler: z.string().optional(),
  payload: z.string().optional(),
  category: ActionCategorySchema,
  source: SourceSchema
});

export type ActionDefinition = z.infer<typeof ActionDefinitionSchema>;
